import { Tenant } from '@innovation-os-ng/core/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TENANT_FEATURE_SELECTOR } from '../constants';
import { TenantState } from '../interfaces/tenant-state.interface';

const selectTenantFeatureSelector = createFeatureSelector<TenantState>(TENANT_FEATURE_SELECTOR);
const selectTenantState = createSelector(selectTenantFeatureSelector, (state: TenantState) => state);
const selectTenants = createSelector(selectTenantState, (state: TenantState) => state?.tenants);
const selectCurrentTenant = createSelector(selectTenantState, (state: TenantState) => state?.currentTenant);
const selectCurrentTenantSlug = createSelector(selectTenantState, (state: TenantState) => state?.currentTenantSlug);
const selectCurrentTenantUri = createSelector(selectTenantState, (state: TenantState) => state?.currentTenant?.tenantUri);
const selectCurrentTenantLogoUri = createSelector(selectTenantState, (state: TenantState) => state?.currentTenant?.logoUri);
const selectTenantUpdated = createSelector(selectTenantState, (state: TenantState) => state?.result?.updated);
const selectTenantBySlug = (slug: string) => createSelector(selectTenants, (tenants: Array<Tenant>) => tenants.find(tenant => tenant.tenantSlug === slug));
const selectTenantByUri = (uri: string) => createSelector(selectTenants, (tenants: Array<Tenant>) => tenants.find(tenant => tenant.tenantUri === uri));

const selectCRUDResults = createSelector(selectTenantFeatureSelector, (state: TenantState) => state.result);


//pending states
const selectTenantLoading = createSelector(selectTenantFeatureSelector, (state: TenantState) => state?.isLoading);
const selectTenantUpdating = createSelector(selectTenantFeatureSelector, (state: TenantState) => state?.isUpdating);
const selectTenantCreating = createSelector(selectTenantFeatureSelector, (state: TenantState) => state?.isCreating);
const selectTenantDeleting = createSelector(selectTenantFeatureSelector, (state: TenantState) => state?.isDeleting);

export const TenantSelectors = {
  selectTenantState,
  selectTenants,
  selectCurrentTenant,
  selectCurrentTenantSlug,
  selectCurrentTenantUri,
  selectCurrentTenantLogoUri,
  selectTenantLoading,
  selectTenantUpdating,
  selectTenantCreating,
  selectTenantDeleting,
  selectTenantUpdated,
  selectTenantBySlug,
  selectTenantByUri,
  selectCRUDResults
};
